module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/pending_arrows-971b68820231e248e8af4dd5ea309bf4.svg";